<template>
<div class='main-list'>
  <!-- 列表渲染区域 -->
  <div class='projects-container'>
    <div class='item' v-if="showCreateProject">
      <div class='create-card'>
        <a @click="createProject"><i class='ppj-icon-plus'></i><p>{{$t('actions.project.new')}}</p></a>
      </div>
    </div>
    <div class="item" :class="{'clear-margin': index % 4 === (showCreateProject ? 2 : 3)}" v-for="(project, index) in projects" :key='project.id' v-show='project.id'>
      <project-card :project='project' @update='update($event, index)' @refresh='refreshData()' />
    </div>
  </div>

  <!-- 滚动加载触发控件 -->
  <infinite-loading :on-infinite="onInfinite" ref='infiniteLoading'>
    <div slot="spinner" style="padding-left:50%;">
      <div class='ppj-icon-spinner' />
    </div>
    <welcome slot="no-results" @click="createProject" />
    <p slot="no-more" class='hint'>{{ $t('actions.category.noMore' )}}</p>
  </infinite-loading>
</div>
</template>

<script>
import lodash from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'

import { createDialog } from '@/assets/scripts/dialog'

import ProjectCard from './item/'
import Welcome from './welcome'
import QuotasRequiredDialog from './quotas_required.dialog'

let statesChecker = null

export default {
  data() {
    return {
      projects: null, // 'null' is different to [], since 'null' stands for 'not initial'
      currentPage: 0,
      totalPages: 1,
      quotasDialog: createDialog(QuotasRequiredDialog)
    }
  },
  watch: {
    projects: function(newValues) {
      this.$emit('has-projects', newValues && newValues.length && newValues.length > 0)
    }
  },
  components: {
    'infinite-loading': InfiniteLoading,
    'project-card': ProjectCard,
    'welcome': Welcome
  },
  computed: {
    catId() {
      return this.$route.params.id ? Number(this.$route.params.id) : null
    },
    showCreateProject() {
      return (this.projects && this.projects.length > 0) && (!this.organization || this.canDo('create_project'))
    },
    permanentsLeft() {
      return this.$store.state.quota.summary.permanents_left
    },
    permanents() {
      return this.$store.state.quota.summary.permanents
    }
  },
  methods: {
    update(data, index) {
      if (!data) {
        this.projects.splice(index, 1)
        this.currentPage -= 1

        if (this.projects.length <= 0) {
          this.refreshData()
        }
      } else {
        this.projects.splice(index, 1, data)
      }
    },
    createProject() {
      let vm = this

      let toCreate = () => {
        vm.$router.push({
          path: '/projects/new',
          query: { catId: vm.$route.params.id }
        })
      }

      vm.$store.dispatch('refresh').then(_ => {
        // 企业用户，额度为0，都提示
        // 个人用户，额度为0，但是是首次，不提示
        if (vm.permanentsLeft === 0 && (vm.organization || vm.permanents !== 0)) {
          vm.quotasDialog({
            cancel: toCreate
          })
        } else {
          toCreate()
        }
      })
    },
    onInfinite() {
      let vm = this
      vm.$store.dispatch('project/index', {
        category_id: vm.catId,
        page: vm.currentPage + 1
      }).then(res => {
        // get rid of duplicate projects
        vm.projects = lodash.unionBy(vm.projects || [], res.data.list, 'id')
        vm.currentPage = res.data.current_page
        vm.totalPages = res.data.total_pages

        window.setTimeout(function() {
          if (res.data.current_page > res.data.total_pages || res.data.list.length === 0) {
            vm.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          } else {
            vm.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          }
        })
      })
    },
    refreshData() {
      let vm = this
      vm.projects = null
      vm.currentPage = 0
      vm.totalPages = 1
      vm.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
    }
  },
  mounted() {
    let vm = this
    let checker = () => {
      // 检查所有状态为不是complete和halt的项目
      let ids = []
      let idsStates = {}
      vm.projects.forEach(p => {
        if (['completed', 'halted'].indexOf(p.state) < 0) {
          ids.push(p.id)
          idsStates[p.id] = p.state
        }
      })

      if (ids.length > 0) {
        // check ids
        vm.$store.dispatch('project/states', {
          ids: ids.join(',')
        }).then(res => {
          for (let id in res.data) {
            if (res.data[id] !== idsStates[id]) {
              // need update ui for this project
              console.log('need update', id)
              let oldIndex = lodash.findIndex(vm.projects, {
                id: Number(id)
              })

              if (oldIndex < 0) break

              vm.$set(vm.projects[oldIndex], 'state', res.data[id])

              if (res.data[id] === 'complete') {
                // need update project info
                vm.$store.dispatch('project/get', {
                  id: Number(id),
                  force: true
                }).then(res => {
                  vm.projects.splice(oldIndex, 1, res.data)
                })
              }
            }
          }
          statesChecker = window.setTimeout(checker, 10000)
        }).catch(error => {
          error.mute = true
        })
      }
    }
    statesChecker = window.setTimeout(checker, 10000)
  },
  beforeDestroy() {
    if (statesChecker) {
      window.clearTimeout(statesChecker)
      statesChecker = null
    }
  }
}
</script>

<style lang="scss">
.projects-container {
    overflow: hidden;

    .item {
        float: left;
        width: 240px;
        height: 360px;
        background-color: $color-white-base;
        margin-right: 30px;
        margin-bottom: 30px;

        &.clear-margin {
            margin-right: 0;
        }
    }

    .create-card {
        overflow: hidden;
        width: 100%;
        height: 100%;
        box-shadow: $box-shadow-base;
        position: relative;
        text-align: center;
        padding-top: 115px;
        a:hover {
            text-decoration: none;
        }

        .ppj-icon-plus {
            font-size: 2.4em;
            cursor: pointer;
            &:before {
                margin: 0;
            }
        }

        p {
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?92028d16